import { Middleware } from 'redux';
import { CurrencyEnum } from '@spectrocoin/sc-currencies';
import MerchantOrder, { MerchantOrderStatus } from '../interfaces/MerchantOrder';
import FooterActions from './FooterSlice/FooterActions';
import OrderActions from './OrderSlice/OrderActions';
import { cancelOrder } from './OrderSlice/OrderThunks';
import PreorderActions from './PreorderSlice/PreorderActions';
import { createOrder } from './PreorderSlice/PreorderThunks';
import { fetchProject } from './PublicFormSlice/PublicFormThunks';

const AppMiddleware: Middleware<void> =
	(storeApi) =>
	(next) =>
	(
		action:
			| ReturnType<typeof PreorderActions.setPayCurrency>
			| ReturnType<typeof createOrder.fulfilled>
			| ReturnType<typeof fetchProject.fulfilled>
			| ReturnType<typeof cancelOrder.fulfilled>
	) => {
		switch (action.type) {
			case PreorderActions.setPayCurrency.type:
				if (action.payload) {
					storeApi.dispatch(FooterActions.setBuyCurrency(action.payload as CurrencyEnum));
				}
				break;
			case createOrder.fulfilled.type:
				storeApi.dispatch(OrderActions.setOrder(action.payload as MerchantOrder));
				break;
			case cancelOrder.fulfilled.type:
				storeApi.dispatch(OrderActions.setOrderStatus(MerchantOrderStatus.EXPIRED));
				break;
			default:
				break;
		}

		next(action);
	};

export default [AppMiddleware];
